import { Injectable } from '@angular/core';

@Injectable()
export class ApiConstants {
    public static readonly API_BASE_PATH: string = 'api';
    public static readonly API_PATH_TEAMS: string = 'teams';
    public static readonly API_PATH_ADMIN: string = 'admin';
    public static readonly API_PATH_JOBS: string = 'jobs';

    public static readonly API_GROUP_ACCOUNT_TYPES: string = 'account-types';
    public static readonly API_GROUP_PERMISSIONS: string = 'permissions';
    public static readonly API_GROUP_ROLES: string = 'roles';
    public static readonly API_GROUP_TEAM_MEMBERS: string = 'team-members';
    public static readonly API_GROUP_AUTH: string = 'auth';
    public static readonly API_GROUP_SSO_CLIENTS: string = 'sso-clients';

    public static readonly API_METHOD_EMAIL: string = 'email';
    public static readonly API_METHOD_STATISTICS: string = 'statistics';
    public static readonly API_METHOD_TRANSFER_OWNERSHIP: string = 'transfer-ownership';
    public static readonly API_METHOD_LOGOUT: string = 'logout';
    public static readonly API_METHOD_AUTHORIZE: string = 'authorize';

    public static readonly REQUEST_METHODS = {
        POST: 'POST',
        GET: 'GET',
        PUT: 'PUT',
        PATCH: 'PATCH',
        DELETE: 'DELETE'
    };

    public static readonly RELAYTER_API_HEADERS = {
        X_RELAYTER_API_KEY: 'x-relayter-api-key',
        X_RELAYTER_TEAM_ID: 'x-relayter-team-id',
        X_RELAYTER_AUTHORIZATION_TYPE: 'x-relayter-authorization-type',
        AUTHORIZATION: 'authorization'
    };
}
